






























import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import NewTranslation from '@/components/i18n/NewTranslation.vue';
import Loader from '@/components/Loader.vue';
import SelectPrintModePage from '@/views/taxcard/transaction/print-overlay/SelectPrintModePage.vue';
import CreditCardPrinterPage from '@/views/taxcard/transaction/print-overlay/CreditCardPrinterPage.vue';
import TicketSelectPage from '@/views/taxcard/transaction/TicketSelectPage.vue';
import HomePrinterPage from '@/views/taxcard/transaction/print-overlay/HomePrinterPage.vue';
import { NamedRoutes } from '@/routes/routes';
import PrintingApi from '@/app/api/PrintingApi';
import i18next from 'i18next';
import { State } from 'vuex-class';
import BIObject from '@/types/taxcard/BIObject';
import { TaxcardRoutes } from '@/app/api-routes';

enum PrintModes {
  HOME = 'home',
  CC_TERMINAL = 'cc',
}

enum Pages {
  PRINT_MODE_SELECT = 'printModeSelectPage',
  HOME_PRINTER = 'homePrinterPage',
  CC_PRINT_PAGE = 'ccPrinterPage',
  TICKET_SELECT = 'ticketSelectPage',
}

@Component({
  components: {
    HomePrinterPage,
    TicketSelectPage,
    CreditCardPrinterPage,
    SelectPrintModePage,
    Loader,
    NewTranslation,
  },
})
export default class TransactionPrintOverlay extends Vue {
  @Prop({ type: Object, required: false })
  public transaction!: any | null;

  @Prop(Boolean)
  public isPrintOverlayOpen!: Boolean;

  @State
  public customerUUID!: string;

  @Emit()
  public close(): void {}

  activePage = Pages.PRINT_MODE_SELECT;

  selectedMode = '';
  selectedTaxcardIds: number[] = [];
  isDownloading = false;

  get pages() {
    return Pages;
  }

  get selectedTaxcards() {
    if (!this.transaction || !this.transaction.taxcards) {
      return [];
    }
    return this.transaction.taxcards.filter((taxcard: any) => this.selectedTaxcardIds.includes(taxcard.id));
  }

  get maxTicketsToSelect() {
    return this.selectedMode === PrintModes.CC_TERMINAL ? 10 : 0;
  }

  onHomePrinterSelect() {
    this.selectedMode = PrintModes.HOME;
    this.activePage = Pages.TICKET_SELECT;
  }

  onCcPrinterSelect() {
    this.selectedMode = PrintModes.CC_TERMINAL;
    this.activePage = Pages.TICKET_SELECT;
  }

  onTicketSelect(ticketIds: number[]) {
    this.selectedTaxcardIds = ticketIds;
    if (this.selectedMode === PrintModes.CC_TERMINAL) {
      this.activePage = Pages.CC_PRINT_PAGE;
    } else if (this.selectedMode === PrintModes.HOME) {
      this.startPDFDownload();
    }
  }

  async startPDFDownload() {
    if (this.isDownloading) {
      return;
    }
    this.isDownloading = true;
    const result = await PrintingApi.preparePrint(this.transaction.taxId, this.selectedTaxcardIds, this.customerUUID);
    if (result && result.printId) {
      window.location.replace(TaxcardRoutes.getPrintPDF(result.printId, i18next.t('transactionDetail.taxcard.title')));
      setTimeout(() => {
        this.isDownloading = false;
        this.onPrintSuccess();
      }, 1000);
    }
  }

  onPrintSuccess() {
    // NOTE: state printed postponed; keep taxcards active
    // PrintingApi.setTaxcardsPrinted(this.selectedTaxcardIds, this.customerUUID);

    // this.$store.commit('openOverlay', {
    //   overlayName: 'Info',
    //   overlayData: {
    //     title: i18next.t('transaction.printOverlay.printed.title'),
    //     message: i18next.t('transaction.printOverlay.printed.message'),
    //   },
    // });

    this.close();
  }
}
